import Section from 'components/common/Section'
import { SectionHeader } from './SectionHeader'
import { Button } from 'designsystem/Button'
import { Crisp } from 'crisp-sdk-web'

interface BottomCTASectionProps extends React.HTMLAttributes<HTMLElement> {
  title: string
  subline: string
}

export const BottomCTASection = ({
  title,
  subline,
}: BottomCTASectionProps): JSX.Element | null => {
  return (
    <Section
      bgColor='white'
      verticalPadding='xs'
      className='max-w-768 mx-auto text-left sm:text-center'
    >
      <SectionHeader title={title} subline={subline} paddingToContent='small' />

      <Button
        pageType='marketing'
        color='blue'
        onClick={() => Crisp.chat.open()}
      >
        Book a call with us!
      </Button>
    </Section>
  )
}
